// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 21"
    {...props}
  >
    <path
      fill="#FDD012"
      d="M10.1221 0.609786C10.5011 -0.0851551 11.4989 -0.085155 11.8779 0.609786L14.511 5.43791C14.6549 5.70163 14.9096 5.88673 15.2049 5.94203L20.6104 6.95429C21.3884 7.09999 21.6968 8.04901 21.153 8.62421L17.3748 12.6204C17.1685 12.8387 17.0711 13.1382 17.1098 13.4361L17.8175 18.8898C17.9193 19.6748 17.112 20.2613 16.397 19.9219L11.4288 17.5636C11.1575 17.4347 10.8425 17.4347 10.5712 17.5636L5.60304 19.9219C4.88795 20.2613 4.08067 19.6748 4.18253 18.8898L4.8902 13.4361C4.92885 13.1382 4.83154 12.8387 4.62517 12.6204L0.847025 8.62421C0.303214 8.04901 0.611568 7.09999 1.38961 6.95429L6.7951 5.94203C7.09037 5.88673 7.34514 5.70163 7.48897 5.43791L10.1221 0.609786Z"
    />
  </svg>
);
const IconFilledStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconFilledStar;
